export enum SuggestionType {
  Cheapest = 'cheapest',
  MostPopular = 'mostPopular',
}

export enum InfoIconPosition {
  None = 'none',
  Inside = 'inside',
  Outside = 'outside',
}

export enum SuggestionTypeSelectorSize {
  Small = 'size-s',
  Normal = 'size-m',
  Large = 'size-l',
}
